import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layouts/paginated-layout.js";
import { Subpage, Callout } from "course-components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Subpage slug="review" mdxType="Subpage">
      <h3>{`Reviewing Crucial Skills`}</h3>
      <p>{`In this first unit we will take time to review some of the crucial skills from the end of Web 1 as we apply them to a new project on a much more accelerated schedule.`}</p>
      <p>{`See these lessons from Web Design I on the box model and basic layout:`}</p>
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://web1.learnuxd.com/lessons/08-box-model/"
          }}>{`Lesson 8: The Box Model`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://web1.learnuxd.com/lessons/09-css-layout/"
          }}>{`Lesson 9: CSS Layout Tools`}</a></li>
      </ul>
      <p>{`In particular, take a look at this lesson from Web Design I on building layouts with Flexbox:`}</p>
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://web1.learnuxd.com/lessons/10-building-layouts/"
          }}>{`Lesson 10: Building Layouts`}</a></li>
      </ul>
    </Subpage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      